import { DarkTheme } from "../.internal/themes/DarkTheme";
export default DarkTheme;